const path = require('path');
const conf = require('../../../conf/properties.js');
import QueryBuilder from './QueryBuilder';
import axios from 'axios';

import properties from '../../../conf/properties';

const rckmsRsEndpoint = `${properties.rsBaseServiceUri}${properties.rsCrudContextPath}/api/resources`.format('rckms');
// const cdsRsEndpoint = `${properties.rsBaseServiceUri}${properties.rsCrudContextPath}/api/resources`.format('cds');
// const coreRsEndpoint = `${properties.rsBaseServiceUri}${properties.rsCrudContextPath}/api`.format('core');

class MTSClient {
    constructor(uiConfig = null, userDTO = null) {
        if (uiConfig == null) {
            throw new Error('No UI Config provided to MTSClient');
        }
        this.uiConfig = uiConfig;
        if (userDTO == null) {
            throw new Error('No User DTO provided to MTSClient');
        }
        this.userDTO = userDTO;

        this.sessionId = null;
        this.fetchSession();
    }

    init(conf) {}

    fetchSession() {
        let sessionId = window.sessionStorage.getItem('sessionId');
        // TODO move to root
        // let sessionDTO = window.sessionStorage.getItem('sessionDTO');
        // let userDTO = window.sessionStorage.getItem('rckmsUserDTO');
        this.sessionId = sessionId;
    }

    fetchConditions(withChild = null) {
        //TODO: Maybe grab this from uiConfig in Session Storage
        if (this.sessionId == null) {
            this.fetchSession();
        }
        let crudURI = `${rckmsRsEndpoint}/conditions`;
        let query = {
            sessionId: this.sessionId
        };
        if (withChild === 'externalReference') {
            query.filter = 'scope%3DEXTERNAL';
            query.property = `queryClass%3DByJurisdictionIdReferenceScope`;
        } else if (withChild === 'internalReference') {
            query.filter = 'scope%3DINTERNAL';
            query.property = `queryClass%3DByJurisdictionIdReferenceScope`;
        } else if (withChild === 'logicSet') {
            query.property = `queryClass%3DByJurisdictionIdLogicSet`;
            query.filter = '';
        }

        if (this.userDTO.role !== 'RCKMS_ADMINISTRATOR') {
            if (query.filter.length > 0) {
                query.filter += '%2C';
            }
            query.filter += `jurisdictionId%3D${this.userDTO.jurisdictionId}`;
        }

        return new Promise((resolve, reject) => {
            let queryString = QueryBuilder(query);
            let requestUri = `${crudURI}${queryString}`;
            axios
                .get(requestUri)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    fetchReferences(conditionId = null, scope = null) {
        if (conditionId != null && scope != null) {
            return new Promise((resolve, reject) => {
                let referenceUri = `${rckmsRsEndpoint}/conditionreferences`;
                let query = {
                    filter: `conditionId=${conditionId},scope=${scope}`,
                    property: `queryClass=ByConditionIdScope`,
                    expand: `ConditionReferenceFileDTO`,
                    sessionId: this.sessionId
                };
                let queryString = QueryBuilder(query);
                let requestUri = `${referenceUri}${queryString}`;
                axios
                    .get(requestUri)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        }
        return Promise.reject();
    }

    fetchLogicSets(conditionId = null) {
        if (conditionId == null) {
            return Promise.reject();
        }

        return new Promise((resolve, reject) => {
            let logicSetUri = `${rckmsRsEndpoint}/logicsets`;
            let query = {
                filter: `conditionId=${conditionId}`,
                property: `queryClass=ByConditionId`,
                sessionId: this.sessionId
            };
            let queryString = QueryBuilder(query);
            let requestUri = `${logicSetUri}${queryString}`;
            axios
                .get(requestUri)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    fetchCriteria(conditionId = null) {
        if (conditionId == null) {
            return Promise.reject();
        }

        return new Promise((resolve, reject) => {
            let criteriaUri = `${rckmsRsEndpoint}/conditioncriteriarels`;
            let query = {
                filter: `conditionId=${conditionId}`,
                property: `queryClass=ByConditionId`,
                sessionId: this.sessionId
            };
            let queryString = QueryBuilder(query);
            let requestUri = `${criteriaUri}${queryString}`;
            axios
                .get(requestUri)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    fetchConditionSpecifications(conditionId = null) {
        if (conditionId == null) {
            return Promise.reject();
        }

        return new Promise((resolve, reject) => {
            let conditionSpecificationsUri = `${rckmsRsEndpoint}/conditionspecifications`;
            let query = {
                filter: `conditionId=${conditionId}`,
                property: `queryClass=ByConditionId`,
                sessionId: this.sessionId
            };
            let queryString = QueryBuilder(query);
            let requestUri = `${conditionSpecificationsUri}${queryString}`;
            axios
                .get(requestUri)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });
    }

    importMany(resources = [], type = null) {
        if (type != null) {
            return Promise.all(resources.map((v) => this.importResource(v, type)));
        } else {
            return Promise.reject('Undefined resource type.');
        }
    }

    importResource(resource = null, type = null) {
        let crudUri = typeof this.uiConfig[type] == 'object' ? this.uiConfig[type].crudRsUri : false;
        if (crudUri) {
            return new Promise((resolve, reject) => {
                if (this.sessionId == null) {
                    reject('No Session Id');
                }
                let query = {
                    sessionId: this.sessionId
                };
                let queryString = QueryBuilder(query);
                let requestUri = `${crudUri}${queryString}`;
                axios
                    .post(requestUri, resource)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        } else {
            return Promise.reject(`No Crud URI for ${type} in uiConfig.`);
        }
    }

    fetchReferenceFile(fileId = null, type = null) {
        let crudUri = typeof this.uiConfig[type] == 'object' ? this.uiConfig[type].crudRsUri : false;
        if (crudUri) {
            return new Promise((resolve, reject) => {
                if (this.sessionId == null) {
                    reject('No Session Id');
                }
                let query = {
                    sessionId: this.sessionId
                };
                let queryString = QueryBuilder(query);
                let requestUri = `${crudUri}/download/${fileId}${queryString}`;
                axios
                    .get(requestUri, {
                        responseType: 'blob'
                    })
                    .then((response) => {
                        // read the file blob as a base64 string
                        const reader = new FileReader();
                        reader.onloadend = (event) => {
                            // reader.result is a data url, but we only care about the data which comes after "base64,"
                            let split = reader.result.split('base64,');
                            if (split.length > 1) {
                                resolve(split[1]);
                            } else {
                                reject('Unable to read file');
                            }
                        };
                        reader.onabort = reader.onerror = (error) => {
                            reject(error);
                        };
                        reader.readAsDataURL(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        } else {
            return Promise.reject(`No Crud URI for ${type} in uiConfig.`);
        }
    }
}

export default MTSClient;
